import { useQuery } from '@tanstack/react-query'

import { getUserDetail } from '@/lib/services/trader.service'

/**
 * React Query hook for fetching user detail data
 * @param address - The user's wallet address
 * @param symbol - The trading symbol
 * @param enabled - Whether the query should be enabled
 * @returns React Query result
 */
export function useUserDetail(address: string, userAddress?: string) {
  return useQuery({
    queryKey: ['userDetail', address, userAddress],
    queryFn: () => getUserDetail(address, userAddress),
    enabled: !!address,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
